export const props = Object.freeze({
  justify: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center", "end", "space-between", "space-around", "space-evenly"].includes(value),
  },
  align: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center", "end", "baseline", "stretch"].includes(value),
  },
  alignContent: {
    type: String,
    default: "start",
    validator: (value) =>
      ["start", "center", "end", "space-between", "space-around", "space-evenly", "stretch"].includes(value),
  },
  tag: {
    type: String,
    default: "div",
  },
  // FIXME: under unknown circumstances, camelCase props are not reactive
  columngap: {
    type: [String, Number],
    default: "var(--sp-comp-row-column-gap, 0.5rem)",
  },
  // FIXME: under unknown circumstances, camelCase props are not reactive
  rowgap: {
    type: [String, Number],
    default: "var(--sp-comp-row-row-gap, 1rem)",
  },
  height: {
    type: String,
    default: "auto",
  },
  noGutters: {
    type: [Boolean, String],
    default: false,
  },
});
